export type Translations = { [key: string]: string | Translations };

const isTranslations = (value: unknown): value is Translations =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const mergeTranslations = (bundled: Translations, remote: Translations): Translations =>
  Object.entries(remote).reduce<Translations>(
    (merged, [key, remoteValue]) => {
      const bundledValue = merged[key];
      merged[key] =
        isTranslations(bundledValue) && isTranslations(remoteValue)
          ? mergeTranslations(bundledValue, remoteValue)
          : remoteValue;
      return merged;
    },
    { ...bundled }
  );
